import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Modal from "react-bootstrap/Modal"; // Asegúrate de tener `react-bootstrap` instalado
import Button from "react-bootstrap/Button";



const MainWorkSpaces = () => {

    const [workspaces, setWorkspaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
    const [selectedWorkspaceName, setSelectedWorkspaceName] = useState("");
    const [reportes, setReportes] = useState([]);
    const [reportesBI, setReportesBI] = useState([]);
    const [reportesactivos, setReportesActivos] = useState([]);
    const [selectedReports, setSelectedReports] = useState([]);
    const [usuariosRoles, setusuarioRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const workspacesAll = null;

    
    const { instance } = useMsal();
    const [embedToken, setEmbedToken] = useState(null); 
    const location = useLocation();
    const { workspaceId } = location.state || {};

    //const servidor = "http://localhost:3000";
    const servidor = "https://analytics.centenario.com.pe";

   const getAccountInfo = () => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      return accounts[0]; // Toma la primera cuenta autenticada
    }
    return null;
  };

   const userAuth = getAccountInfo();

   const user = {
    name: userAuth.name,
    email: userAuth.username, // Cambia a la URL de la foto del usuario
  };

  const handleLogout = () => {
    instance.logoutRedirect({
     //postLogoutRedirectUri: "http://localhost:3000", // Cambia esto según tu entorno
     postLogoutRedirectUri: "https://analytics.centenario.com.pe", // Cambia esto según tu entorno
    });
};

    const handleWorkspaceSelect = (id) => {
        /*navigate("/mainreport", { state: { workspaceId: id } });*/

        setSelectedWorkspaceId(id);

        // Opcional: obtener nombre del workspace
        const workspace = workspaces.find((w) => w.id === workspaceId);
        setSelectedWorkspaceName(workspace?.name || "");
      };

      useEffect(() => {
            const fetchToken = async () => {
                if (!userAuth) {
                    //console.log("Usuario no autenticado, redirigiendo...");
                    await instance.loginPopup({
                        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
                    });
                }
    
                try {
                    const tokenResponse = await instance.acquireTokenSilent({
                        scopes: ["https://analysis.windows.net/powerbi/api/.default"],
                        account: userAuth,
                    });
                    //console.log("TokenCliente:", tokenResponse.accessToken);
                    setEmbedToken(tokenResponse.accessToken);
                } catch (error) {
                    console.error("Error al obtener el token:", error);
                }
            };
    
            fetchToken();
        }, [instance, userAuth,embedToken]);


    useEffect(() => {
        const fetchWorkSpaces = async () => {
          try {
            const response = await axios.get(
              `https://api.powerbi.com/v1.0/myorg/groups`,
              {
                headers: {
                  Authorization: `Bearer ${embedToken}`,
                },
              }
            );
            // Imprime todos los reportes en la consola
            if (response.data && response.data.value) {
              //console.log("Todos los workspace de Power BI:");
              response.data.value.forEach((report) => {
                //console.log(`Report Name: ${report.name}, Workspace ID: ${report.id}`);
              });
            } else {
              //console.log("No se encontraron workspaces.");
            }
            setWorkspaces(response.data.value); // Array de reportes

          } catch (err) {
            //console.error("Error fetching workspaces:", err);
            setError("Error al cargar los workspace.");
          } finally {
            setLoading(false);
          }
        };
    
        if (embedToken) {
          fetchWorkSpaces();
        } else {
          //setError("Token no proporcionado. No se puede cargar la lista de reportes.");
          setLoading(false);
        }
      }, [embedToken]);

      

      const handleWorkspaceSelect_f = async (id) => {
        setSelectedWorkspaceId(id);

        // Opcional: obtener nombre del workspace
        const workspace = workspaces.find((w) => w.id === id);
        setSelectedWorkspaceName(workspace?.name || "");

        // Aquí iría tu fetch real al backend o API de Power BI
        const response = await axios.get(
              `https://api.powerbi.com/v1.0/myorg/groups/${id}/reports`,
              {
                headers: {
                  Authorization: `Bearer ${embedToken}`,
                },
              }
            );

        //const data = await response.data.json(); // [{ id, name }, ...]

        //try {
          const [ reportesRes ] = await Promise.all([
            axios.get(`${servidor}/api/reportesadm?workspaceId=${id}`)
          ]);

          const reportesActivos = reportesRes.data;

          const reportesBI = response.data.value;
          // Crear set de IDs activos para búsqueda rápida
          const activosSet = new Set(reportesActivos.map(r => r.id.trim()));

          // Combinar ambas listas y añadir campo `activo`
          const reportesCombinados = reportesBI.map((rep) => {
          const isActive = activosSet.has(rep.id.trim());
          
          return {
            ...rep,
            activo: isActive,
          };
        });

          setReportes(reportesCombinados);
          //console.log(reportesCombinados);

        setShowModal(true);
};



  return (
    <div style={{overflow:"auto"}}>
        <Header user={user} onLogout={handleLogout}></Header>
        <div style={{ height: '90vh', width: 'auto' }}>
             <div className="container my-4">
      <h2 className="text-center mb-4" style={{fontFamily:"montserrat-extrabold"}} >
        WORKSPACE  - RUD
      </h2>
      <div className="row">
        {workspaces.map((workspace) => (
          <div className="col-md-4 mb-4" key={workspace.id}>
            <div
              className="card h-100 shadow-sm"
              style={{ border: "2px solid red", borderRadius: "10px" }}
            >
              <div className="card-body">
                <h6 className="card-title text-black">{workspace.name.toUpperCase()}</h6>
                <p className="card-text text-secondary">
                  {workspace.isReadOnly
                    ? "Read-Only Access"
                    : "Full Access"}
                </p>
              </div>
              <div
                className="card-footer"
                style={{
                  backgroundColor: "red",
                  borderTop: "2px solid black",
                }}
              >
                <button
                  className="btn btn-dark btn-sm w-100"
                  onClick={() => handleWorkspaceSelect_f(workspace.id)}
                >
                  Ver Reportes
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
</div>
   
    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
      <Modal.Header closeButton>
        <h5 className="text-center" style={{fontFamily:"montserrat-extrabold", textAlign:"center", paddingTop:"10px"}}>
        {selectedWorkspaceName}
      </h5>
      </Modal.Header>
      <Modal.Body>
        {reportes.length === 0 ? (
          <p style={{fontFamily:"montserrat-extrabold"}}>No hay reportes disponibles.</p>
        ) : (
          <div className="list-group">
            {reportes.map((rep) => (
              <label key={rep.id} className="list-group-item">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={rep.activo}
                 onChange={() => {
                    setReportes((prev) =>
                        prev.map((r) =>
                          r.id === rep.id ? { ...r, activo: !r.activo } : r
                        )
                      );
                  }}
                />
                {rep.name}
              </label>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={async () => {

            const reportesSeleccionados = reportes
                /*.filter((r) => r.activo)*/
                .map((r) => ({
                  id: r.id,
                  name: r.name,
                  activo: r.activo,
                }));
                //console.log(reportesSeleccionados);
              /*if (reportesSeleccionados.length === 0) {
                alert("Debes seleccionar al menos un reporte.");
                return;
              }*/

            await axios.post(`${servidor}/api/saveSelectedReports`, {
                workspaceId: selectedWorkspaceId,
                workspaceName: selectedWorkspaceName,
                selectedReports: reportesSeleccionados,
            });
            setShowModal(false);
            alert("Selección guardada correctamente");
          }}
        >
          Guardar selección
        </Button>
      </Modal.Footer>
    </Modal>
    
    </div>
    
  );
};

export default MainWorkSpaces;

const styless = `
  .list-group-item:hover {
    background: transparent !important;
    color: #d32f2f !important;
    font-family: 'montserrat-extrabold' !important;
    font-size: inherit !important;
  }
  
`;

const styleTag = document.createElement("style_wk");
styleTag.innerHTML = styless;
document.head.appendChild(styleTag);
